import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {ShareClassViewModel} from '../view-models/share-class.view-model';

@Component({
    selector: 'app-share-classes-card',
    templateUrl: './share-classes-card.component.html',
    styleUrls: ['./share-classes-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareClassesCardComponent {
    public readonly currentPage = input.required<PageViewModel<ShareClassViewModel>>();
    public readonly rowClicked = output<ShareClassViewModel>();

}
